"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRequiredProps = void 0;
const customError_1 = require("../customError/index.js");
/**
 * @function checkRequiredProps
 * @description Method that validates if all keys of a given object are present in a given list of strings.
 * Used to check if all required props are present in a component.
 * If any of the required props is missing, it throws an error.
 *
 * @param {object} props - The props object to be validated.
 *
 * @param {string[]} requiredProps - List of the required props.
 *
 * @param {string} callerName - The name of the component that is calling this function.
 */
const checkRequiredProps = (props, requiredProps, callerName) => {
    const hasProps = Boolean(props && Object.keys(props).length);
    const isMissingProp = hasProps && requiredProps.some((prop) => !Object.keys(props).includes(prop));
    if (!hasProps || isMissingProp) {
        const throwCustomError = new customError_1.CustomError(callerName);
        throwCustomError.missingRequiredProps();
    }
};
exports.checkRequiredProps = checkRequiredProps;
